// Copyright 2020 TOKU Systems Inc.

import moment from 'moment-timezone';

export class ApiKey {
  readonly id: string;
  readonly userId: string;
  readonly expiresAt: moment.Moment;
  readonly ttl: moment.Duration;
  readonly description: string;
  readonly fingerprint: string;
  readonly token?: string;
  readonly issuedAt: moment.Moment;

  constructor(
    id: string,
    userId: string,
    expiresAtMillis: number,
    ttl: number,
    description: string,
    fingerprint: string,
    token?: string
  ) {
    this.id = id;
    this.userId = userId;
    this.expiresAt = moment.utc(expiresAtMillis);
    this.ttl = moment.duration(ttl);
    this.issuedAt = this.expiresAt.clone().subtract(this.ttl);
    this.description = description;
    this.fingerprint = fingerprint;
    this.token = token;
  }
}

export interface ApiKeyRecord {
  id: string;
  description: string;
  fingerprint: string;
  issuedAt: string;
  issuedAtMillis: number;
  expiresAt: string;
  expiresAtMillis: number;
  token?: string;
}
